export default __webpack_public_path__ + "static/media/ishopify-homepage.c8bc23f0.png";